(() => {
    function initCookieConsent() {
        const cookieConsentBanner = document.getElementById("cookie-consent-banner");
        const acceptAllButton = document.getElementById("accept-all-cookies");
        const savePreferencesButton = document.getElementById("save-cookie-preferences");
        const declineButton = document.getElementById("decline-cookie-preferences");

        const consentsCookieData = {
            userHasSetCookies: false,
            functionalityCookies: false,
            statisticCookies: false,
            marketingCookies: false,
        };

        acceptAllButton.addEventListener("click", function () {
            consentsCookieData.userHasSetCookies = true;
            consentsCookieData.functionalityCookies = true;
            consentsCookieData.statisticCookies = true;
            consentsCookieData.marketingCookies = true;
            saveSelection();
        });

        declineButton.addEventListener("click", function () {
            consentsCookieData.userHasSetCookies = true;
            consentsCookieData.functionalityCookies = false;
            consentsCookieData.statisticCookies = false;
            consentsCookieData.marketingCookies = false;
            saveSelection();
        });

        savePreferencesButton.addEventListener("click", function () {
            const functionalityCheckbox = cookieConsentBanner.querySelector("#functionality");
            const analyticsCheckbox = cookieConsentBanner.querySelector("#analytics");
            const marketingCheckbox = cookieConsentBanner.querySelector("#marketing");
            consentsCookieData.userHasSetCookies = true;
            consentsCookieData.functionalityCookies = functionalityCheckbox.checked;
            consentsCookieData.statisticCookies = analyticsCheckbox.checked;
            consentsCookieData.marketingCookies = marketingCheckbox.checked;
            saveSelection();
        });

        function saveSelection() {
            Vendallion.setCookie("ConsentChecked", JSON.stringify(consentsCookieData), 365);
            window.location.reload();
        }
    }

    if (document.readyState === "complete" || document.readyState === "interactive") {
        initCookieConsent();
    } else {
        document.addEventListener("DOMContentLoaded", initCookieConsent);
    }
})();
